export default __webpack_public_path__ + "static/media/WhatsApp Video 2023-07-04 at 18.55.22.049cf609.mp4";